export default {
  step9:[
    {
      id:82,
      step: 9,
      tab:1,
      stepJp: "刻印",
      font:"",
      name: "ブロック体（大文字のみ）",
      property: "ringText",
      val: "block",
      option:null,
      summary:"",
      price:0,
    },
    {
      id:83,
      step: 9,
      tab:1,
      stepJp: "刻印",
      font:"",
      name: "筆記体",
      property: "ringText",
      val: "cursive",
      option: null,
      summary:"",
      price:0,
    },
    {
      id:84,
      step: 9,
      tab:1,
      stepJp: "刻印",
      font:"",
      name: "書体や文字内容は未定",
      property: "ringText",
      val: "undecided",
      option: null,
      summary:"",
      price:0,
    },

    {
      id:85,
      step: 9,
      tab:2,
      stepJp: "刻印",
      font:"",
      name: "ゴシック（日本語可）",
      property: "ringText",
      val: "gothic",
      option: null,
      summary:"",
      price:9000,
    },
    {
      id:86,
      step: 9,
      tab:2,
      stepJp: "刻印",
      font:"",
      name: "tamari風",
      property: "ringText",
      val: "tamari",
      option: null,
      summary:"",
      price:9000,
    },
    {
      id:87,
      step: 9,
      tab:2,
      stepJp: "刻印",
      font:"",
      name: "手書き風",
      property: "ringText",
      val: "handwritten",
      option: null,
      summary:"",
      price:9000,
    },
    {
      id:88,
      step: 9,
      tab:2,
      stepJp: "刻印",
      font:"",
      name: "明朝（日本語可）",
      property: "ringText",
      val: "mincho",
      option: null,
      summary:"",
      price:9000,
    },
    {
      id:89,
      step: 9,
      tab:2,
      stepJp: "刻印",
      font:"",
      name: "サイン",
      property: "ringText",
      val: "sign",
      option: null,
      summary:"",
      price:9000,
    },
    {
      id:90,
      step: 9,
      tab:2,
      stepJp: "刻印",
      font:"",
      name: "書体や文字内容は未定",
      property: "ringText",
      val: "undecided",
      option: null,
      summary:"",
      price:9000,
    },
    //イラストない price:10000
  ]
}
